/*
 * お気に入り（ウィッシュリスト）
 *
 * 保存先は2つある。
 *   - 端末の localStorage: 未ログインでも押せるようにするため、常にここが起点
 *   - 顧客メタフィールド wishlist.items: ログイン中だけ、App Proxy 経由で同期する
 *
 * ログインした時点で両者を突き合わせ、和集合を正とする。どちらかで消えた分が
 * 勝手に消えるより、残っている方が事故が小さいため。
 */
(function () {
  'use strict';

  var config = (window.theme && window.theme.wishlist) || {};
  var STORAGE_KEY = 'lucen:wishlist';
  var endpoint = config.endpoint || '/apps/maac/wishlist';
  var signedIn = Boolean(config.signedIn);
  var saveTimer = null;

  function readLocal() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(parsed)) return [];
      return parsed.filter(function (handle) {
        return typeof handle === 'string' && handle.length > 0;
      });
    } catch (error) {
      // プライベートブラウジングなどで読めないことがある。その場合は空として扱う。
      return [];
    }
  }

  function writeLocal(handles) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (error) {
      /* 保存できなくてもページは動かす */
    }
  }

  function union(first, second) {
    var merged = first.slice();
    second.forEach(function (handle) {
      if (merged.indexOf(handle) === -1) merged.push(handle);
    });
    return merged;
  }

  function same(first, second) {
    return first.length === second.length && first.every(function (handle, index) {
      return handle === second[index];
    });
  }

  /* ------------------------------------------------------------------ *
   * 表示の更新
   * ------------------------------------------------------------------ */

  function paint() {
    var handles = readLocal();

    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      var active = handles.indexOf(button.dataset.wishlistHandle) !== -1;
      var label = active ? 'お気に入りから削除' : 'お気に入りに追加';

      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', label);
      button.setAttribute('title', label);

      var text = button.querySelector('[data-wishlist-label]');
      if (text) text.textContent = active ? 'お気に入り登録済み' : 'お気に入りに追加';
    });

    document.querySelectorAll('[data-wishlist-count]').forEach(function (badge) {
      var number = badge.querySelector('[data-wishlist-count-number]') || badge;
      number.textContent = handles.length;
      badge.hidden = handles.length === 0;
    });

    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { handles: handles } }));
  }

  /* ------------------------------------------------------------------ *
   * 会員との同期
   * ------------------------------------------------------------------ */

  function save(handles) {
    if (!signedIn) return;

    window.clearTimeout(saveTimer);
    // 連打をまとめる。送るのは毎回リスト全体で、サーバ側は受け取った内容で置き換える。
    saveTimer = window.setTimeout(function () {
      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ handles: handles }),
      }).catch(function () {
        /* 通信に失敗しても端末内には残っている。次の操作かログインで送り直される。 */
      });
    }, 400);
  }

  function pull() {
    if (!signedIn) return;

    fetch(endpoint, { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        if (!data || data.ok !== true || !Array.isArray(data.handles)) return;

        var local = readLocal();
        var merged = union(data.handles, local);

        if (!same(merged, local)) {
          writeLocal(merged);
          paint();
        }

        // 端末にしか無かった分をサーバへ返す。ログイン直後の引き継ぎはここで成立する。
        if (!same(merged, data.handles)) save(merged);
      })
      .catch(function () {
        /* 取得できなければ端末内の内容のまま使う */
      });
  }

  /* ------------------------------------------------------------------ *
   * 操作
   * ------------------------------------------------------------------ */

  function toggle(handle) {
    var handles = readLocal();
    var position = handles.indexOf(handle);

    if (position === -1) {
      handles.push(handle);
    } else {
      handles.splice(position, 1);
    }

    writeLocal(handles);
    paint();
    save(handles);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wishlist-toggle]');
    if (!button || !button.dataset.wishlistHandle) return;

    // カードでは星が商品リンクの上に乗っている。遷移させない。
    event.preventDefault();
    event.stopPropagation();
    toggle(button.dataset.wishlistHandle);
  });

  // 別タブで押された分を反映する。
  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) paint();
  });

  // クイックビューや無限スクロールで後から増えたカードにも状態を塗る。
  document.addEventListener('shopify:section:load', paint);
  document.addEventListener('wishlist:paint', paint);

  window.theme = window.theme || {};
  window.theme.wishlist = Object.assign({}, config, {
    getHandles: readLocal,
    toggle: toggle,
    paint: paint,
  });

  paint();
  pull();
})();
